import React, { useEffect, useState } from 'react';

import './Landing.css';

interface ILanding {
    handleRender: () => void;
}

export default function Landing(props: ILanding) {
    const [videoEnded, setVideoEnded] = useState(false);
    const videoRefLanding = React.useRef<HTMLVideoElement>(null);
    const buttonRefLanding = React.useRef<HTMLButtonElement>(null);
    function handleVideoEnd() {
        if (!videoEnded) {
            setVideoEnded(true);
            setTimeout(() => {
                props.handleRender();
            }, 1000);
        }
    }
    function handlePlay() {
        if (videoRefLanding.current) {
            videoRefLanding.current.play().catch(() => {
                if (buttonRefLanding.current) {
                    buttonRefLanding.current.click();
                }
            });
        }
    }
    useEffect(() => {
        handlePlay()
        // eslint-disable-next-line 
    }, [])

    return (
        <div data-aos="fade" data-aos-once data-aos-easing={"ease-in-out"} className={`landing-main  ${videoEnded ? 'video-dissolve-out' : ''}`} >
            <img className='left-ellipse' src="assets/images/landing/left_ellipse.png" alt="ellipse_left" width={"100%"} />
            <img className='right-ellipse' src="assets/images/landing/right_ellipse.png" alt="ellipse_right" width={"100%"} />
            <video
                className='video-abs'
                muted
                playsInline
                ref={videoRefLanding}
                onEnded={handleVideoEnd}
                controls={false}
                preload="metadata"
            >
                <button style={{ display: "none" }} ref={buttonRefLanding} onClick={handlePlay}>PLAY</button>
                <source src={"/assets/videos/hero-video.mp4"} type="video/mp4" />
            </video>
            <div className='landing-img'>
                <img src="assets/images/landing/hero-image.jpg" alt="landing" />
            </div>
        </div>

    );
}
